/*
 * Author : Nirak Kr. Bharti
 * Email  : kumarniraj.447@gmail.com
 */

 
/***************************
 * URL , DOMAIN , HOST
 * *************************/
// Complete URL
const hitUrl = window.location.href;

//Panel Domain Name
const domain = window.location.hostname;

//Panel Protocol https/http
const host = window.location.protocol;

//Panel used port
const port = window.location.port;

// Generated URL
var BASEURL = (port != '' && port != undefined) ?  host + "//" + domain + ":" + port : host + "//" + domain ;

const USERTYPE  = $('meta[name="userType"]').attr('content');
const VISITOR   = '3';
const CHANNEL   = '2';
const ADMIN     = '1';

const LOCKED    = '2';
const UNLOCKED  = '1';
const DEFAULT   = '0';
const SHOWCHAR  = 40;
const ELLIPSESTEXT = "...";
const MORETEXT = "more";
const LESSTEXT = "less";


const ASKBOX_SELECT_TITLE = 'Do you really want to delete ?';     
const ASKBOX_SELECT_TEXT = "You will not be able to recover this ";     
const ASKBOX_CONFIRM_BUTTON = 'Okay';     
const ASKBOX_CANCEL_BUTTON = 'Cancel';     

const OOPS   = 'Oh oops !';
const GREAT   = 'Great Job !';
const HITHERE   = 'Hi there !';
const WELCOMENOTICE   = 'Warm Thanks !';
const SOMETHING_WENT_WRONG = '1';

const PAYMENY_PENDING   = '1';
const PAYMENY_SUCCESS   = '2';
const PAYMENY_FAILED    = '3';
const PAYMENY_CANCEL    = '4';


// Ajax token setup
$.ajaxSetup( {
    headers: {
        'X-CSRF-TOKEN': $( 'meta[name="csrf_token"]' ).attr( 'content' ),
        'XSRF-TOKEN': $( 'meta[name="csrf_token"]' ).attr( 'content' )
    }
} );

/**
 * Get URL parameters
 */
function getUrlParams() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

/**
 * Redirect on given url
 * @param {*} tm 
 * @param {*} src 
 */
function redirectSomewhere(tm = 5000, src = '') {
    window.setTimeout(function(){

        // Move to a new location or you can do something else
        sweetSuccessPopUpWithTitle( 'Redirecting ....', GREAT );
        window.location.href = src;

    }, tm);
}
/**
 * Function to replace param value in URL
 */

function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

// Toolpit JS
// Apply Bootstrap tool-Tip
// $('[data-toggle="tooltip"]').tooltip();
// $('[data-toggle="popover"]').popover();


'use strict';

var searchBox = document.querySelectorAll('.search-box input[type="text"] + span');

searchBox.forEach((elm) => {
	elm.addEventListener('click', () => {
		elm.previousElementSibling.value = '';
	});
});

/** 
 * Set GMT data 
 */
$(document).ready(function (e) {
    /*************************************************************************************
    *  All Date Picker JS 
    *  Date Picker .date1 .date2
    *  dtpRange1 - date range 1 && dtpRange2 - date range 2 && ie; 21122019 - 291221019
    **************************************************************************************/
    // 2 Date box 
    // $(".date1").keypress(function(event) {event.preventDefault();}).datepicker();
    // $(".date2").keypress(function(event) {event.preventDefault();}).datepicker();

    // // Date Time Picker
    // $('#startDate').datetimepicker();

    // // 1 Date Range
    // $('#dtpRange1').datepicker();
    // $('#dtpRange2').datepicker({
    //     useCurrent: false //Important! See issue #1075
    // });
    // $("#dtpRange1").on("dp.change", function (e) {
    //     $('#dtpRange2').data("DatePicker").minDate(e.date);
    // });
    // $("#dtpRange2").on("dp.change", function (e) {
    //     $('#dtpRange1').data("DatePicker").maxDate(e.date);
    // });

    // // guess user timezone
    // var currentTime = new Date();
    // var currentTimezone = currentTime.getTimezoneOffset();
    // currentTimezone = (currentTimezone/60) * -1;
    // currentTimezone = currentTimezone.toFixed(2);
    // var gmt = '', gmtLocal = '';
    // if (currentTimezone !== 0) {
    //     gmt += currentTimezone > 0 ? '+0' : ' '; //toFixed
    //     gmt += currentTimezone;

    //     gmtSpliArr = gmt.split('.');
    //     gmtPart2 = (gmtSpliArr[1] * 60/100);
        
    //     gmtLocal = gmt.split('.')[0] + ":" + gmtPart2;
    //     $('#tz').val(gmtLocal);
    //     $('.tz').val(gmtLocal);
    // }else{
    //     gmt += "+00";
    //     gmtLocal = gmt.split('.')[0] + ":" + gmt.split('.')[1];
    //     $('#tz').val(gmtLocal);
    //     $('.tz').val(gmtLocal);
    // }

    // Set timezone
    // $.ajax({
    //     url: '/set-user-timezone',
    //     type: "POST",
    //     data: {'tz' : gmtLocal},
    //     dataType: 'json',
    //     beforeSend: function ( bfrSend ) {
    //         NProgress.start();
    //     },
    //     error: function () {
    //         NProgress.done();
    //     },
    //     success: function ( response ) {
    //         NProgress.done();
    //         if(response.code == '200') {
    //             console.log(response.result) ;
    //         } else{
    //             console.log('message') ;
    //         }
            
    //     }
    // } );
    
    // TOASTR SETTING
    // toastr.options = {
    //     "closeButton": true,
    //     "debug": false,
    //     "newestOnTop": true,
    //     "progressBar": true,
    //     "positionClass": "toast-top-right",
    //     "preventDuplicates": true,
    //     "onclick": null,
    //     "showDuration": "200",
    //     "hideDuration": "300",
    //     "timeOut": "3000",
    //     "extendedTimeOut": "5000",
    //     "showEasing": "swing",
    //     "hideEasing": "linear",
    //     "showMethod": "fadeIn",
    //     "hideMethod": "fadeOut",
    //     "maxOpened": 1
    // }

}); 
$( function () {
    // Show popover always on load
    // $('.popInfo').popover('show');
    
    /**
     * ajax Before Progress bar 
     * @returns {undefined}
     */
    ajaxBeforSend = function () {
        NProgress.start();
    };

    /**
     *
     * @returns {undefined}
     */
    var cancelSuccess = function ( msg ) {
        NProgress.done();
        toastr.success( msg, 'Successfully', {
            "closeButton": true,
            "debug": true,
            "newestOnTop": true,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "preventDuplicates": true
        } );
    };

    /**
     *
     * @returns {undefined}
     */
    var ajaxSuccess = function ( msg ) {
        NProgress.done();
        toastr.success( msg, 'Successfully', {
            "closeButton": true,
            "debug": true,
            "newestOnTop": true,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "preventDuplicates": true
        } );
    };

} );


// Start : More/Less
$(window).on("load",function(){
    
    
});
// Set more button if allowed 

// More Less
$(document).on('click', '.morelink' , function() {
    if($(this).hasClass("less")) {
        $(this).removeClass("less");
        $(this).html(MORETEXT);
    } else {
        $(this).addClass("less");
        $(this).html(LESSTEXT);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
});

function dynamicallylessContent(){
    $('.more').each(function() {
        var content = $(this).html();

        if(content.length > SHOWCHAR) {

            var c = content.substr(0, (SHOWCHAR-1));
            var h = content.substr(SHOWCHAR-1, content.length - (SHOWCHAR-1));

            var html = c + '<span class="moreelipses">'+ELLIPSESTEXT+'</span><span class="morecontent"><span>' + h + '</span>&nbsp;<a href="" class="morelink">'+MORETEXT+'</a></span>';

            $(this).html(html);
        }

    });
}
// End : More/Less



var strongRegex = new RegExp( "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})" );
var mediumRegex = new RegExp( "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})" );

$( "#password" ).keyup( function () {
    var value = $( this ).val();
    var pasLen = value.length;
    if ( strongRegex.test( value ) ) {
        $( "#passwd_strength" ).css( { "background": "green", "width": "100%" } );
    }
    else if ( mediumRegex.test( value ) ) {
        $( "#passwd_strength" ).css( { "background": "orange", "width": "50%" } );
    }
    else {
        if ( pasLen > 6 ) {
            $( "#passwd_strength" ).css( { "background": "red", "width": "25%" } );
            $( "#oneMinimum" ).css( { "color": "green", "font-weight": "bold" } );
        }
        else if ( pasLen < 6 && pasLen > 3 ) {
            $( "#passwd_strength" ).css( { "background": "red", "width": "1%" } );
        }
        else {
            $( "#passwd_strength" ).css( { "background": "red", "width": "0%" } );
        }

    }
} );

//check phone number validation

function isNumber( evt ) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if ( charCode == 46 ) {
        return true;
    }
    else if ( charCode > 31 && (charCode < 48 || charCode > 57) ) {
        return false;
    }
    return true;
}

function utcToLocal($dateTime){
    $dt = $dateTime + " UTC";
    var date = new Date($dt);
    date.toString()
}

/**
 * Equal Height 
 */
var maxHeight = 0;
$(".image-list-inner").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});
$(".image-list-inner").height(maxHeight);

// AlertMe
function showModal(modalID){
    var res = $('#'+ modalID).modal('show');
}
// HideMe
function hideModal(modalID){
    var res = $('#'+ modalID).modal('hide');
}

// Get Age By d.o.b
function returnAgeByDob($dob){
    $dobArr = $dob.split('-');
    var b = moment([$dobArr[2], $dobArr[1], $dobArr[0]]);
    
    var years = moment().diff(b, 'year');
    b.add(years, 'years');
    
    var months = moment().diff(b, 'months');
    b.add(months, 'months');

    var days = moment().diff(b, 'days');

    return years + ' years ' + months + ' months ' + days + ' days';
}

// Get string by ucfirst
function ucfirst(str){
    if(str != undefined && str != ''){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }else{
        return '';
    }     
}


/**
* AJAX SUCCESS ALERT BOX 
*
*/
var sweeAlertPopUp = function (msg) {
    toastr.clear();
    toastr.success(msg, 'Successfully', {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    });
};

// Method for show error message only
var sweetErrorPopUp = function (msg) {
    toastr.clear();
    toastr.error(msg, 'Error found', {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    });
};

// Method for show error message and its title also
var sweetErrorPopUpWithTitle = function (msg, title) {
    toastr.clear();
    toastr.error(msg, title, {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    });
};

// Method for show error message and its title also
var sweetSuccessPopUpWithTitle = function (msg, title) {
    toastr.clear();
    toastr.success(msg, title, {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    });
};

// Method for show error message and its title also
var sweetInfoPopUpWithTitle = function (msg, title) {
    toastr.clear();
    toastr.warning(msg, title, {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    });
};


/**
 * AJAX SUCCESS ALERT BOX
 *
 */
var getStrWithLen = function (str, len) {
    if(isEmpty(str)){
        return '' ;
    }
    if(str.length > len) {
        return str.slice(0, len) + "..";
    } else {
        return str;
    }
};

/**
 * method to time format from UTC
 * @param UNIX_timestamp
 * @returns {string}
 */
function timeConverter(UNIX_timestamp,  type){
    var a = new Date(UNIX_timestamp);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
        hour = ("0" + hour).slice(-2);
    var min = a.getMinutes();
        min = ("0" + min).slice(-2);
    var sec = a.getSeconds();


    // type == 1 : D M Y H I S
    if(type == 1) {
        return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    }

    // type == 2 : D M Y
    if(type == 2) {
        return date + ' ' + month + ' ' + year;
    }

    // type == 3 : D M
    if(type == 3) {
        return date + ' ' + month ;
    }

    // type == 3 : D M
    if(type == 4) {
        return month  + ' ' + date ;
    }

    // type == 4 : H I
    if(type == 5) {
        return hour + ':' + min;
    }
}

// Return last element from array
var last =  function(array, n) {
    if (array == null)
        return void 0;
    if (n == null)
        return array[array.length - 1];
    return array.slice(Math.max(array.length - n, 0));
};

/**
 * Method to check empty object
 * @param obj
 * @returns {boolean}
 */
function isEmptyObj(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

/**
 * Method to check empty var
 * @param obj
 * @returns {boolean}
 */
function isEmpty(val){
    return (val === undefined || val == null || val.length <= 0) ? true : false;
}


/**
 * Method to scroll down to Bottom
 * @param id
 */
function goToByScroll(id){
    $("."+id).animate({ scrollTop: document.getElementById('chat-body-wrapper').scrollHeight - $("."+id).offset().top}, 'slow');
}

/**
 * Method to replace new line as br tag
 * @param str
 * @returns {*}
 */
function strNewLineToBR(str) {
    if(str != undefined || str != ''){
        return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    } else {
        return '';
    }
    
}


// Get Value Grouped Checkboxes 
function getGroupedCheckedBoxesVals(chkBxName){
    var values = new Array();
    $.each($("input[name='"+chkBxName+"[]']:checked"), function() {
      values.push($(this).val());
      // or you can do something to the actual checked checkboxes by working directly with  'this'
      // something like $(this).hide() (only something useful, probably) :P
    });
    return values;
}



/**
 * Method to pop message after ajax service
 *
 * @param {type} msg
 * @returns {undefined}
 */
var ajaxSuccess = function ( msg ) {
    NProgress.done();
    toastr.clear();
    toastr.success( msg, 'Successfully', {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    } );
};

/**
 * Method to pop message after ajax service
 *
 * @param {type} msg
 * @returns {undefined}
 */
var ajaxError = function ( msg ) {
    NProgress.done();
    toastr.clear();
    toastr.error( msg, 'Error', {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": true
    } );
};

// Method to validate url
var elmUrl;
var validateUrl = function (str) {
  
  if(!elmUrl){
    elmUrl = document.createElement('input');
    elmUrl.setAttribute('type', 'url');
  }
  elmUrl.value = str;
  return elmUrl.validity.valid;
}

function getCaret(el)
{
    if (el.selectionStart) {
        return el.selectionStart;
    } else if (document.selection) {
        el.focus();

        var r = document.selection.createRange();
        if (r == null) {
            return 0;
        }

        var re = el.createTextRange(),
            rc = re.duplicate();
        re.moveToBookmark(r.getBookmark());
        rc.setEndPoint('EndToStart', re);

        return rc.text.length;
    }
    return 0;
}

// Start Loader
$( function () {
    NProgress.start();
} );
//stop Loader
$(window).on("load",function(){
    NProgress.done();
    // Start - Show More JS
    $('body').find('.more').each(function() {
        var content = $(this).html();

        if(content.length > SHOWCHAR) {

            var c = content.substr(0, (SHOWCHAR-1));
            var h = content.substr(SHOWCHAR-1, content.length - (SHOWCHAR-1));

            var html = c + '<span class="moreelipses">'+ELLIPSESTEXT+'</span><span class="morecontent"><span>' + h + '</span>&nbsp;<a href="" class="morelink">'+MORETEXT+'</a></span>';

            $(this).html(html);
        }

    });
    $('body').find(".morelink").on("click",function(){
        alert(22);
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(MORETEXT);
        } else {
            $(this).addClass("less");
            $(this).html(LESSTEXT);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
    // End - Show More JS
});

// Search Text Form Validation
$( function () {
    // on click search button
    $('#searcTextButton').on("click",function(){
        var searchTxt = $('#searcTextBox').val().trim();
        if(searchTxt == '' || searchTxt == ' ' || searchTxt == '  ') {
            sweetErrorPopUp( 'Please enter text in search box and then press "Enter"' );            
        } else{
            console.log(replaceUrlParam(hitUrl, 'search', searchTxt));
            window.location = replaceUrlParam(hitUrl, 'search', searchTxt);
        }
    });
    // on enter in search box
    $('input#searcTextBox').keydown(function (e) {
        if (e.keyCode == 13) {
            var searchTxt = $('#searcTextBox').val().trim();
            if(searchTxt == '' || searchTxt == ' ' || searchTxt == '  ') {
                sweetErrorPopUp( 'Please enter text in search box and then press "Enter"' );            
                e.preventDefault();
                return false;                
            } else{
                console.log(replaceUrlParam(hitUrl, 'search', searchTxt));
                window.location = replaceUrlParam(hitUrl, 'search', searchTxt);
            }
        }
    });



} );

// console.log(getUrlParams());

// Ajax Start Stop Handler
$("#loading").ajaxStart(function() {
    $(this).show();
}).ajaxStop(function() {
    $(this).hide();
    $("#st-tree-container").show();
});





// Search Text Form Validation
$( function () {
    // Likes // Dislikes 
    $(document).on("click", ".article-like", function() { 
        // form.submit();
        if(USERTYPE == '') {
            alert('You are required to login first.');
            return false;
        } else {
            if(USERTYPE != VISITOR) {
                sweetErrorPopUpWithTitle('Please login as a visitor and then like this post', 'oh Opps ',);                        
            } else{
                
                // Proceed like-dislike aria-hidden="true"
                like_status = 'true';

                if($(this).attr('like-status') == undefined) {
                    $(this).attr('like-status', like_status);
                } else {
                    if($(this).attr('like-status') == '') {
                        like_status = 'true';
                    } else if($(this).attr('like-status') == 'false') {
                        like_status = 'true';
                    } else{
                        like_status = 'false';
                    }
                    $(this).attr('like-status', like_status);
                }
                
                // Set All Hand up icon onClick
                var articleBtnIconClass = '.article-like-id-'+$(this).attr('article-id');
                $(articleBtnIconClass).each(function() {
                    ele = $(this).find('i').first();
                    if(ele.hasClass('fa-thumbs-up')) {
                        ele.removeClass('fa-thumbs-up');
                        ele.addClass('fa-thumbs-o-up');
                    } else {
                        ele.addClass('fa-thumbs-up');
                        ele.removeClass('fa-thumbs-o-up');
                    }
                });
                
                // increase / decrease count
                $(articleBtnIconClass).each(function() {
                    var eleContent      = $(this).html();
                    var eleContentArr   = eleContent.split('</i>');
                    var newContent      = '';
                    var total_likes     = parseInt($(this).attr('total-likes'));
                    if(ele.hasClass('fa-thumbs-up')) {
                        // Like
                        total_likes     = total_likes + 1;
                        newContent      = eleContentArr[0] + '</i> ' + + total_likes;
                        $(this).html(newContent);
                    } else {
                        // Dis-like
                        total_likes     = total_likes - 1;
                        newContent      = eleContentArr[0] + '</i> ' + + total_likes;
                        $(this).html(newContent);
                    }
                    // update count in ele attribute
                    $(this).attr('total-likes', total_likes);
                });

                var data = {
                    'article_id'    : $(this).attr('article-id'),
                    'like'          : like_status == 'false' ? '0' : '1',
                    '_token'        : $('meta[name="csrf-token"]').attr('content')
                };
                // Ajax Call 
                $.ajax( {
                    method: "POST",
                    url: URL + "/like-dislike-article",
                    data: data,
                    beforeSend: function () { 
                        ajaxBeforSend();
                    },
                    error: function () {
                        NProgress.done();
                        sweetErrorPopUpWithTitle('Something error found, Try later', 'Oh oops !');
                    },
                    success: function ( res ) {
                        NProgress.done();
                        if ( 200 == res.CODE ) {
                            var alertTitle = like_status == 'false' ? OOPS : GREAT;
                            sweetSuccessPopUpWithTitle( res.MESSAGE, alertTitle );
                        }else{
                            sweetSuccessPopUpWithTitle(res.MESSAGE, 'Sorry :-;');       
                        }
                    }

                });   

                
            }
        }

    });

    
});


/**
 * Razor Payment 
 */

// Payment Success Handler
function demoSuccessHandler(transaction) {
    // You can write success code here. If you want to store some data in database.
    // $("#paymentDetail").removeAttr('style');
    // $('#paymentID').text(transaction.razorpay_payment_id);
    // var paymentDate = new Date();
    // $('#paymentDate').text(
    //     padStart(paymentDate.getDate()) + '.' + padStart(paymentDate.getMonth() + 1) + '.' + paymentDate.getFullYear() + ' ' + padStart(paymentDate.getHours()) + ':' + padStart(paymentDate.getMinutes())
    // );
    // console.log(transaction);
    $.ajax({
        method: 'post',
        url: "/verify-payment-order",
        data: {
            // "_token": "FIYALg0Gd8HpsRCtSAe7znCY9FHYF8McMGACOKku",
            "payload": transaction
        },
        beforeSend:function(){
            sweetInfoPopUpWithTitle( 'Please wait while verifying your payment', GREAT );
        },
        error: function ( errorRes ) {
            NProgress.done();
            sweetErrorPopUpWithTitle( SOMETHING_WENT_WRONG, OOPS );
        },
        // complete: function (r) {
        //     sweetSuccessPopUpWithTitle( 'Please visit the page again', WELCOMENOTICE );
        //     // console.log('complete');
        //     // console.log(r);
        // },
        success: function (r) {
            console.log(r);

            if(r.code == '200') {
                swal({text:r.msg});
                sweetSuccessPopUpWithTitle( r.msg, GREAT );
            } else {
                swal({text:r.msg});
                sweetErrorPopUpWithTitle( r.msg, GREAT );
            }

            $('#donationAmt').val('');
            $('#donationAmountModal').modal('hide');
            $('#rz_data-name').val('');
            $('#rz_data-id').val('');
            $('#rz_data-logo').val('');
            
        }
    })
}

$(document).on('click', '#paybtn', function () {
    if(USERTYPE == '') {
        sweetErrorPopUpWithTitle('You are required to login as a visitor.', HITHERE); 
        return false;
    } else {
        if(USERTYPE != VISITOR) {
            sweetErrorPopUpWithTitle('Please login as a visitor and then donate to this channel', 'oh Opps ',);                        
        } else{
            $('#donationAmt').val('');
            $('#donationAmountModal').modal('show');
            $('#rz_data-name').val($('#paybtn').attr('data-name'));
            $('#rz_data-id').val($('#paybtn').attr('data-id'));
            $('#rz_data-logo').val($('#paybtn').attr('data-logo'));
        }
    }
    
});

$('form#proceedDonationForm').on("submit",function(e){
    e.preventDefault();
    let donationAmount = document.getElementById('donationAmt').value;
    // swal({text:'You wanna  donate '+ donationAmt});
    if(donationAmount < 1){
        swal({text:'Minimum donation amount must be 1.00 INR.'});
        sweetErrorPopUpWithTitle('Minimum 1.00 INR', 'oh Opps ',);
        $('#donationAmt-error').css('display', 'grid');
        $('#donationAmt').focus();
    }
    else {
        $('#donationAmt-error').css('display', 'none');
        setUpRazorPayment(donationAmount)   
    }
});

// validate amount field on keyUp
$('#donationAmt').on("keyup",function(){
    let donationAmount = document.getElementById('donationAmt').value;
    // swal({text:'You wanna  donate '+ donationAmt});
    if(donationAmount < 1){
        sweetErrorPopUpWithTitle('Minimum 1.00 INR', 'oh Opps ',);
        $('#donationAmt-error').css('display', 'grid');
    }
    else {
        $('#donationAmt-error').css('display', 'none');
    }
});


// Digit Only text Box
$(document).on('input keydown keyup mousedown mouseup select contextmenu drop', ".digitOnly", function() {
    this.value = this.value.replace(/[^0-9\.]/g,'');
} );


function padStart(str) {
    return ('0' + str).slice(-2)
}

// Check-login Method
async function checkUserLogin(){
    var isLogin = false;
    $.ajax({
        url : assetBaseUrl + "check-login",
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
        },    			
        success: function(data){
            isLogin = data.error;
            console.log(data.userProfile);
            $('#login_ctx').attr('ctx', data.error); 
            // if(data.error == true) {
            //     console.log(2222222);
            //     $('.with-login').addClass('without-login');
            //     let logHTML = '<a href="javascript:void(0)"><img class="profile-pic" src="'+ assetBaseUrl +'images/user_img.png" alt="'+ data.userProfile.first_name +'"> </a>';
            //     logHTML  += '<div> <span>Welcome,</span> <strong class="profile-name"> Shyam '+ data.userProfile.first_name + ' ' + data.userProfile.last_name +'</strong> </div>';
            //     logHTML  += '<a href=""> <img src="'+ assetBaseUrl +'images/header-arrow.svg" alt=""> </a>';
            //     logHTML  += '<div class="user-info-list"> <ul><li><a href="'+ assetBaseUrl +'logout">logout</a></li> </ul> </div>';
            //     $(document).find('.without-login').html(logHTML );
            //     $('.without-login').removeClass('with-login');
            // }
            
        },
    });
}
